import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga-pr': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_yoga_m_glucose~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_tai_chi_yoga_m_glucose'
					),
			},
			funnel: {
				id: 'ob-male-tai-chi-yoga-glucose',
				locale: ['en'],
			},
		},
	},
]

export default config
